import { fetchDraftInvoices, DraftInvoiceParams, DraftInvoiceResponse , deleteDraft } from '../../api/draft-invoice/index';


export const fetchDraftInvoicesApi = async (params: DraftInvoiceParams): Promise<DraftInvoiceResponse> => {
    const response = await fetchDraftInvoices(params);
    return response;
};

export const fetchDraftInvoicesWithCustomParams = async (params: Record<string, any>): Promise<DraftInvoiceResponse> => {
    return await fetchDraftInvoices(params as DraftInvoiceParams);
};

export const deleteDraftInvoicing = async (
  preId: number
)=> {
  return deleteDraft(preId);
};

